import { createContext, ReactNode, useEffect, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

type NavigationContextType = {
  navigate: NavigateFunction;
  errorStatus: number | null;
  setErrorStatus: (status: number | null) => void;
};

export const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const [errorStatus, setErrorStatus] = useState<number | null>(null);

  useEffect(() => {
    import('@src/api/apiClient/axiosClient')
      .then((axiosClient) => {
        axiosClient.setErrorStatus(setErrorStatus);
      })
      .catch((error) => {
        console.error('Failed to load axiosClient:', error);
      });
  }, []);

  return (
    <NavigationContext.Provider value={{ navigate, errorStatus, setErrorStatus }}>
      {children}
    </NavigationContext.Provider>
  );
};
